export default "__VITE_ASSET__BWCHs4Ik__"